<header class="app-header" [class.is-open]="navOpen()">
  <div class="app-header__inner">
    <a routerLink="/main/dashboard" class="brand" aria-label="PulseWatch dashboard">
      <span class="brand__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64"><path d="M9 35h11l5-12 8 24 6-17 3 5h13" /></svg>
      </span>
      <span class="brand__name">PulseWatch</span>
    </a>

    <nav class="app-nav" aria-label="Main">
      <a routerLink="/main/dashboard" routerLinkActive="is-active" (click)="closeAll()">Projects</a>
      @if (isAdmin) {
        <a routerLink="/main/admin/dashboard" routerLinkActive="is-active" (click)="closeAll()">Admin</a>
      }
      <a routerLink="/knowledge-base">Docs</a>
    </nav>

    <div class="app-header__actions">
      <div class="user-menu">
        <button
          type="button"
          class="user-menu__trigger"
          [attr.aria-expanded]="menuOpen()"
          aria-haspopup="menu"
          aria-label="Account menu"
          data-testid="header-user-menu"
          (click)="toggleMenu($event)"
        >
          <span class="avatar" aria-hidden="true">{{ initials(userName$ | async) }}</span>
          <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
        </button>

        @if (menuOpen()) {
          <div class="user-menu__panel" role="menu">
            <div class="user-menu__who">
              <span class="avatar avatar--lg" aria-hidden="true">{{ initials(userName$ | async) }}</span>
              <div>
                <p class="user-menu__label">Signed in as</p>
                <p class="user-menu__name">{{ userName$ | async }}</p>
              </div>
            </div>
            <a role="menuitem" routerLink="/main/account" (click)="closeAll()" data-testid="header-account">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>
              Account
            </a>
            <a role="menuitem" routerLink="/main/organization" (click)="closeAll()" data-testid="header-organization">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0" /><path d="M16 4.5a3.5 3.5 0 0 1 0 7" /><path d="M18 14.5a6.5 6.5 0 0 1 3.5 5.5" /></svg>
              Organization
            </a>
            <a role="menuitem" routerLink="/main/api-keys" (click)="closeAll()" data-testid="header-api-keys">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="7.5" cy="15.5" r="4.5" /><path d="m10.7 12.3 9.3-9.3" /><path d="m16 7 3 3" /><path d="m19 4 2 2" /></svg>
              API keys
            </a>
            <a role="menuitem" routerLink="/knowledge-base" (click)="closeAll()">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 19.5V5a2 2 0 0 1 2-2h14v16H6.5A2.5 2.5 0 0 0 4 21.5" /><path d="M8 7h8" /></svg>
              Documentation
            </a>
            <hr />
            <button type="button" role="menuitem" class="is-danger" (click)="logout()" data-testid="header-logout">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5" /><path d="M21 12H9" /></svg>
              Log out
            </button>
          </div>
        }
      </div>

      <button
        type="button"
        class="nav-toggle"
        [attr.aria-expanded]="navOpen()"
        aria-label="Toggle navigation"
        (click)="toggleNav($event)"
      >
        <span></span>
      </button>
    </div>
  </div>
</header>
